const reabRouteLevelTwoHeader = [
  {
    group: 'Centro',
    columns: [
      {
        name: 'Id Origem',
        id: 'id-origem',
        show: true
      },
      {
        name: 'Nome Origem',
        id: 'nome-origem',
        show: true
      },
      {
        name: 'Id Destino',
        id: 'id-origem',
        show: true
      },
      {
        name: 'Nome Destino',
        id: 'nome-origem',
        show: true
      }
    ]
  },
  {
    group: 'Rota',
    columns: [
      {
        name: 'Id Rota',
        id: 'id-id',
        show: true
      },
      {
        name: 'Id Level 2',
        id: 'id-level',
        show: true
      }
    ]
  }
]
export default reabRouteLevelTwoHeader
